/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Try_Library_Roleplay_BodyInputs */



/**
* | output |
* | --- |
* | "Try a practice conversation from the library. You get feedback on your approach afterwards." |
*
* @param {Nudge_Try_Library_Roleplay_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_try_library_roleplay_body = /** @type {((inputs?: Nudge_Try_Library_Roleplay_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Try_Library_Roleplay_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Probeer een oefengesprek uit de bibliotheek. Je krijgt achteraf feedback op je aanpak.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Essayez une conversation d'entraînement de la bibliothèque. Vous recevez ensuite un retour sur votre approche.")
	return /** @type {LocalizedString} */ ("Try a practice conversation from the library. You get feedback on your approach afterwards.")
});